import {
  GetParentObject,
  Comparison,
  QuestionNamesById,
  QuestionThreadParent,
  TriggerValue,
} from '@src/app-components/dynamic-form/types';

export const nprQuestionNameByIdV2: QuestionNamesById = {
  1: 'npr_NavWotus',
  2: 'npr_DumpOcean',
  3: 'npr_DischargeWotus',
  4: 'npr_WotusOfUS',
  5: 'npr_FloatingDock',
  6: 'npr_S404',
  7: 'npr_Fallback',
  8: 'npr_PileStructure',
  9: 'npr_PileEffectsFill',
  10: 'npr_DischargeInProjectBoundary',
  11: 'ex_Toxic307',
  12: 'ex_ReachReduced',
  13: 'ex_DischargeFarming',
  14: 'ex_EstablishedFarming',
  15: 'ex_EmergMaintenance',
  16: 'ex_OriginalFillDesign',
  17: 'ex_ReconstructAfterDamage',
  18: 'ex_TempImpactMaintenance',
  19: 'ex_ConstructionPonds',
  20: 'ex_SignificantAlterations',
  21: 'ex_ConstructionPondsMinimumSize',
  22: 'npr_file_upload_1',
  23: 'ex_ConstructionDitch',
  24: 'ex_ConstructTempBasin',
  25: 'ex_DischargeFillRoads',
  26: 'ex_ConstructionRoads',
  27: 'ex_StateApproved',
};

export const nprQuestionIdByNameV2 = Object.fromEntries(
  Object.entries(nprQuestionNameByIdV2).map(([key, value]) => [value, parseInt(key)])
);

export const getParentObjectV2: GetParentObject = (
  parentId: number,
  parentTypeId: number,
  comparison: Comparison,
  triggerValue: TriggerValue
): QuestionThreadParent => {
  const parentName = nprQuestionNameByIdV2[parentId as keyof typeof nprQuestionNameByIdV2] as string;

  return {
    parentId,
    parentName,
    comparison,
    triggerValue,
    parentTypeId,
  };
};
